import { EventConfig } from "../../types/global";

export const actionTypes = {
    SET_EVENT_CONFIG: 'SET_EVENT_CONFIG',
    CLEAR_EVENT_CONFIG: 'CLEAR_EVENT_CONFIG',
};

// Action creators
export const setEventConfig = (payload: EventConfig) => ({
    type: actionTypes.SET_EVENT_CONFIG,
    payload,
});

export const clearEventConfig = () => ({
    type: actionTypes.CLEAR_EVENT_CONFIG,
});

